import { useTranslation } from "react-i18next";

import type { Logic } from "../constants";
import { getLogicLabel } from "../labels";

type LogicDividerProps = {
  logic?: Logic;
};

export function LogicDivider({ logic }: LogicDividerProps) {
  const { t } = useTranslation();

  if (!logic) return null;

  return (
    <div aria-hidden className="flex items-center gap-3">
      <span className="h-px flex-1 bg-border" />
      <span className="px-1 font-mono text-sm font-semibold tracking-wide text-muted-foreground">
        {getLogicLabel(t, logic)}
      </span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
